import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Type } from 'projects/c1-backend/src/app/db/type';
import { AddressesService } from 'projects/c1-backend/src/app/services/addresses.service';
import { TypesService } from 'projects/c1-backend/src/app/services/types.service';
import { AddressDetailsComponent } from 'projects/c1-backend/src/app/views/address/address-details/address-details.component';
import { AddressComponent } from 'projects/c1-backend/src/app/views/address/address.component';
import { Globals } from 'projects/core/src/globals';
import { Model } from 'projects/core/src/include/model';
import { User } from 'projects/core/src/include/structures';
import { UsersComponent } from 'projects/core/src/settings/users/users.component';
import { Dossier, DossierPhase } from '../../../dossier';
import { DossierService } from '../../../services/dossier.service';

@Component({
  selector: 'app-detailphase',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent extends Model<Dossier> implements OnInit,AfterViewInit {
  tab=0;
  tab_phase=-1;

  @ViewChild('modalSelectTypes')
  modalSelectTypes:TemplateRef<any>;
  modalSelectTypesRef:NgbModalRef;

  @ViewChild('modalNote')
  modalNote:TemplateRef<any>;
  modalNoteRef:NgbModalRef;
  log_note:string="";
  log_id_phase:number;
  log_state:number;

  types:Type[]=[];
  id_section=0;

  

  get user(){
    return Globals.user;
  }
  
  constructor(
    private route1: ActivatedRoute,
    private dossierService: DossierService,
    private addressesService:AddressesService,
    private typesService:TypesService,
    private modalService:NgbModal
  ) { 
    super(route1,dossierService);
  }
  modulename="dossier";

  ngOnInit(): void {

    this.title = 'Dettaglio Pratica';
    super.ngOnInit.apply(this, arguments); 
    this.record=new Dossier();

    this.typesService.getTypes("dossier").subscribe((items)=>{
      this.types=items;
    });

  
    this.afterGetItem=()=>{
      if(this.record.id==0){ //se è un nuovo record apri il wizard 
        this.openSelectTypes();
      }else{
        if(this.record.title) {
          this.title=this.record.code+" ("+this.record.title+")";
        }else{
          this.title=this.record.code
        }

        try{
          this.record['errors']=JSON.parse(this.record.errors);
        }catch{
          this.record['errors']=[];
        }
      }
    }
   
  }

  ngAfterViewInit(): void {
    this.getItem();
  }

  selectAddress(){
    Globals.modal.showModal(AddressComponent,[{"name":"mode","value":"modal"},{"name":"title","value":"Seleziona un'anagrafica"}],(instance)=>{
      let r=instance['recordSelected'];

      this.OnSelectAddress(r);

    });
  }

  OnSelectAddress(r){
    if(r){
      this.record.addressItem=r;
      this.record.id_address=r.id;
      
      if(this.module.getParam("user_assignment")=="currentuser"){
        this.record.id_user=Globals.user.id;
        this.record.username=Globals.user.name;
      }else{
        this.record.id_user=this.record.addressItem.id_user;
        this.record.username=this.record.addressItem.username;
      }

     
    }
  };

  OnViewAddress(r){
    Globals.modal.showModal(AddressDetailsComponent,[
      {"name":"mode","value":"modal"},
      {"name":"id","value":r.id}
    ],(instance)=>{
      if(instance!=null)
        this.OnSelectAddress(instance['record']);
    });
  }


  searchUser(){
    
    Globals.modal.showModal(UsersComponent,[
      {"name":"mode","value":"modal"},
    ],(instance)=>{
      if(instance){
        
        let user:User=instance['recordSelected'];
        this.linkUser(user);        

      }
    });
  }


  linkUser(user:User){    

   this.record.id_user=user.id;
   this.record.username=user.name;    

  }


  unlinkUser(){
    Globals.modal.showConfirm("","Confermi di voler scollegare l'utente dalla pratica?",()=>{        
      this.record.id_user=0;
      this.record.username="";
    },"Sì, scollega","No. Annulla","warning");
  }


  openSelectTypes(){
    this.modalSelectTypesRef=this.modalService.open(this.modalSelectTypes);

  }

  onSelectType(id_type){
    this.record.id_type=id_type;
    this.modalSelectTypesRef.close("success");
    this.selectAddress();
  }


  getPhaseStatus(id_phase,phase){
    //esplora i log e trova l'ultimo stato di una fase
    let state=0;
    if(this.record.log && this.record.log.length>0){
     
      for(let l of this.record.log){
        if(l['id_phase']==id_phase){
          state=l['state'];
          if(phase)
            phase['state']=state;
        }
      }
    }
   
    return state;


  }

  setPhase(id_phase,state){
    this.dossierService.setPhase(this.record.id,id_phase,state,this.log_note).subscribe((items)=>{
      if(state==4){
        //se la fase è su "Verificata" imposta la procedura sulla fase successiva
        let nextPhase:DossierPhase;
        for(let i=0;i<this.record.phases.length;i++){
          if(this.record.phases[i].id==this.record.id_current_phase){
            if(i<this.record.phases.length-1){
              this.record.id_current_phase=this.record.phases[i+1].id;
              nextPhase=this.record.phases[i+1];
              break;
            }else{
              this.record.state=2;
            }
          }
        }

        //chiedi se la fase abilitata deve essere messa in corso
        if(confirm("Impostare la fase "+nextPhase.title+" in 'in corso'?")){
          this.dossierService.setPhase(this.record.id,this.record.id_current_phase,1,this.log_note).subscribe((items)=>{
            this.dossierService.getLog(this.record.id).subscribe((logs)=>{
              this.record.log=logs;
            });
          });
        }

      }
      
      this.dossierService.getLog(this.record.id).subscribe((logs)=>{
        
        this.record.log=logs;
      });
    });
  }


  getFirstIdSection(id_phase){
    let sections=this.getSections(id_phase);
    if(sections.length>0){
      return sections[0].id;
    }
    return 0;
  }


  expandPhase(id,tab,i) {
    this.id_section=this.getFirstIdSection(id);
    tab==i?this.tab_phase=-1:this.tab_phase=i;
  }
  


  countSections(fields){
    var c=0;
    for(let s of fields){
      if(s.type=="section") c++;
    }
    return c;
  }

  moveNextSection(id_section,fields,test){
    var sections=[];
    for(let s of fields){
      if(s.type=="section") sections.push(s);
    }

    for(let i=0;i<sections.length;i++){
      if(sections[i].id==id_section){
        if(i<sections.length-1){
          if(!test) {
            this.id_section=sections[i+1].id;
            return;
          } else {
            return true; // Verifica se è possibile passare al successivo
          }
        }
      }
    }
  }

  movePrevSection(id_section,fields,test:boolean=false){
    var sections=[];
    for(let s of fields){
      if(s.type=="section") sections.push(s);
    }

    for(let i=0;i<sections.length;i++){
      if(sections[i].id==id_section){
        if(i>0){
          if(!test) {
            this.id_section=sections[i-1].id;
            return;
          } else {
            return true; // Verifica se è possibile passare al precedente
          }
        }
      }
    }
  }
  

  getSections(id_phase){
    for(let p of this.record.phases){
      if(p.id==id_phase)
        return p.sections==null?[]:p.sections;
    }
  }

  updateLog(log){
    this.dossierService.updateLog(log,()=>{
      log['editNote']=false;
    });
  }

  openModalNote(id_phase,state){
    this.log_id_phase=id_phase;
    this.log_state=state;
    this.modalNoteRef=this.modalService.open(this.modalNote);
  }
  confirmModalNote(){
    this.modalNoteRef.close("success");
    this.setPhase(this.log_id_phase,this.log_state);
  }
  closeModalNote(){
    this.modalNoteRef.close("success");
  }

  checkEnableCondition(fields,enable_condition_fieldname,defaultvalue=null,access){
    
    if(access==0) return false;

    if(enable_condition_fieldname){
      for(let f of fields){
        if(f.name==enable_condition_fieldname){

          if(defaultvalue==null || defaultvalue==""){
            if(f.value=='' || f.value==0 || f.value==undefined || f.value==null){
              return false;
            }
          }else{
            const v=defaultvalue.split(";");
            if(v.indexOf(f.value)==-1)
              return false
          }
    
        }
      }
    }

    return true;
  }


  /** Conta quanti (obbligatori) sono compilati per sezione */
  getCompiledField(id_phase,id_section=0){
    let count=0;
    let sections=this.getSections(id_phase);
    for(let s of sections){
      if(s.id==id_section || id_section==0){
        for(let f of s.fields){
          if(f.value=="" && f.required && f.access==1){
            count++;
          }
        }
      }
    }

    return count;
  }

  deleteAlarm(e){
    for(let i=0;i<this.record.errors.length;i++){
      if(this.record.errors[i]==e){
        this.record.errors.splice(i,1);
        return;
      }
    }
  }

  
}
